import { render, staticRenderFns } from "./AuthRedirect.vue?vue&type=template&id=735dd830&scoped=true"
import script from "./AuthRedirect.vue?vue&type=script&lang=js"
export * from "./AuthRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735dd830",
  null
  
)

export default component.exports